module.exports = __webpack_public_path__ + "img/D&D-Elemente_Stern_Kapitel4.866b70a9.svg";